import { Injectable } from "@angular/core";
import * as moment from "moment";
import { SignalRConnection } from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { errorMessages, appSettings } from "../../settings";
import { CommonService } from "../common.service";
import { DashboardService } from "../dashboard.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class AgedOrdersService extends BaseService{

  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastAgedOrders").subscribe(
      (result: any) => {
        console.log("broadcastAgedOrders", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;                 
          widget.errorMessage = null;

          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let Report_Periods = [];          
            let AgedOrdersCount = [];          

            for (let i = 0; i < result.length; i++) {
              let rptdate = "";
              rptdate = this._commonService.formatDate(result[i].REPORT_DATE,appSettings.chartDayFormat);
              if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                Report_Periods.push(rptdate);
                AgedOrdersCount.push(result[i].AGED_ORDERS);               
              }            
            }
           
            widget.chartOptions = this.chartOptions();      
            this.addDataSeries(widget.chartOptions, AgedOrdersCount, 'Aged Orders', 'bar')         
            widget.chartOptions.xAxis.data = Report_Periods;            
            widget.chartOptions.xAxis.axisLabel.rotate = 45;
            this.addZoomBar(widget.chartOptions);            
            widget.errorMessage = null;
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;        
      },
      err => {
        console.log("listenFor broadcastAgedOrders error", err);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/agedorders.service.ts